"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSource = exports.isFunctionNode = exports.isLiteralNode = exports.isNullNode = exports.isFieldNode = void 0;
const lodash_1 = require("lodash");
const parser_1 = require("../language/parser");
const definition_1 = require("./definition");
const isFieldNode = (node) => node.label === 'field';
exports.isFieldNode = isFieldNode;
const isNullNode = (node) => node.label === 'null';
exports.isNullNode = isNullNode;
const isLiteralNode = (node) => node.label === 'literal';
exports.isLiteralNode = isLiteralNode;
const isFunctionNode = (node) => node.label === 'function';
exports.isFunctionNode = isFunctionNode;
const visit = (expression) => {
    const execute = (e) => {
        return e.accept(visitor);
    };
    const visitor = {
        visitFunction(func) {
            return {
                label: 'function',
                name: func.name.lexeme,
                children: func.params.map((param) => execute(param)),
                expression: func,
            };
        },
        visitIdentifier(identifier) {
            return {
                label: 'field',
                path: [identifier.identifier.lexeme],
                expression: identifier,
            };
        },
        visitPath(expression) {
            const propertyNode = execute(expression.property);
            if (!(0, exports.isFieldNode)(propertyNode)) {
                throw new Error(`Expected field`);
            }
            return {
                label: 'field',
                path: [expression.object.lexeme, ...propertyNode.path],
                expression,
            };
        },
        visitNull(nullLiteral) {
            return { label: 'null', expression: nullLiteral };
        },
        visitLiteral(literal) {
            if ((0, lodash_1.isBoolean)(literal.value)) {
                return {
                    label: 'literal',
                    type: definition_1.T.boolean,
                    value: literal.value,
                    expression: literal,
                };
            }
            if ((0, lodash_1.isString)(literal.value)) {
                return {
                    label: 'literal',
                    type: definition_1.T.string,
                    value: literal.value,
                    expression: literal,
                };
            }
            if ((0, lodash_1.isNumber)(literal.value)) {
                return {
                    label: 'literal',
                    type: definition_1.T.number,
                    value: literal.value,
                    expression: literal,
                };
            }
            throw new Error(`Unknown literal type`);
        },
    };
    return execute(expression);
};
const parseSource = (source) => {
    return (0, parser_1.parse)(source).map(visit);
};
exports.parseSource = parseSource;
//# sourceMappingURL=representation.js.map